/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import { GETWORKERLIST } from './constants'

export const getEmployeeList = (payload) => {
  return {
    type: GETWORKERLIST,
    payload,
  }
}

//用户列表
export function fetchEmployeeList() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/EmployeeApi/EmployeeList`
    return fetchData(endpoint).then((data) => {
      dispatch(getEmployeeList(data.list))
      return data
    })
  }
}
export function fetchDelEmployee(id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/EmployeeApi/DelEmployee/id/${id}`
    return fetchData(endpoint).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        dispatch(fetchEmployeeList())
      } else {
        message.error(data.detail)
      }
    })
  }
}

//修改
export function fetchEditEmployee(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/EmployeeApi/EditEmployee`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        dispatch(fetchEmployeeList())
      } else {
        message.error(data.detail)
      }
    })
  }
}

//增加
export function fetchAddEmployee(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/EmployeeApi/AddEmployee`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchEmployeeList())
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubEmployee/action.js